import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import '../App.css';

import bee from '../Images/bee-icon.svg';

class Footer extends Component {
  
    constructor(props) {
        super();
        this.props = props;
    }
  
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentWillUnmount(){

  }

  rerouteTo(URL) {
    // const navigate = useNavigate();
    // navigate('/home')
  }

  render () {
    
    const footerYear = new Date().getUTCFullYear();

    return (
        
      <div className="footer">
              
        <p className="footer-copyright">© {footerYear} Brandon Falcone</p>
     
      </div>
    );
  }
}

export default Footer;
